import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapPin } from 'lucide-react';

// Fix leaflet default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const LocationPicker = ({ onSelect }) => {
  useMapEvents({
    click(e) {
      onSelect(e.latlng.lat, e.latlng.lng);
    }
  });
  return null;
};

const CantiereMap = ({ latitude, longitude, radius, onLocationChange }) => {
  const [position, setPosition] = useState(
    latitude && longitude && latitude !== 0 ? [latitude, longitude] : [41.87, 15.02]
  );

  useEffect(() => {
    if (latitude && longitude && latitude !== 0) {
      setPosition([latitude, longitude]);
    }
  }, [latitude, longitude]);

  const handleSelect = (lat, lng) => {
    setPosition([lat, lng]);
    onLocationChange(lat, lng);
  };

  const handleGPS = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          setPosition([lat, lng]);
          onLocationChange(lat, lng);
        },
        () => alert('Impossibile ottenere la posizione. Attiva il GPS.')
      );
    }
  };

  return (
    <div className="cantiere-map-wrap">
      <div className="cantiere-map-header">
        <span><MapPin size={14} /> GEOLOCALIZZAZIONE CANTIERE</span>
        <button type="button" className="dcb-add-btn" onClick={handleGPS}>
          <MapPin size={13} /> Posizione attuale
        </button>
      </div>
      <div className="cantiere-map-container">
        <MapContainer
          center={position}
          zoom={15}
          style={{ height: '250px', width: '100%', borderRadius: '10px' }}
          key={`${position[0]}-${position[1]}`}
        >
          <TileLayer
            attribution='&copy; OpenStreetMap'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} />
          {radius > 0 && (
            <Circle center={position} radius={radius} pathOptions={{ color: '#3b82f6', fillColor: '#3b82f6', fillOpacity: 0.1 }} />
          )}
          <LocationPicker onSelect={handleSelect} />
        </MapContainer>
      </div>
      <p className="cantiere-map-hint">Clicca sulla mappa per posizionare il cantiere oppure usa "Posizione attuale"</p>
    </div>
  );
};

export default CantiereMap;
